import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdSearch } from "react-icons/md";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { invoiceId } = useParams();

  return (
    <Layout
      {...props}
      invoiceElements={
        invoiceId && (
          <Fragment>
            <NavListSectionHeader>Invoice CI-{invoiceId}</NavListSectionHeader>
            <NavLink end to={`/account/invoice/${invoiceId}`}>
              <NavListItem icon={MdSearch}>View Invoice</NavListItem>
            </NavLink>
          </Fragment>
        )
      }
    />
  );
}
